import { Component, OnInit, ViewChild } from '@angular/core';
import { _HttpClient, ModalHelper } from '@delon/theme';
import { STColumn, STComponent } from '@delon/abc';
import { SFSchema } from '@delon/form';
import { NzMessageService} from 'ng-zorro-antd';
import {AppAppsEditComponent} from "./edit/edit.component";
import {AppAppsViewComponent} from "./view/view.component";
import {CacheService} from "@delon/cache";
import {DictService} from "@dragshalom/servicedemo";

@Component({
  selector: 'app-app-apps',
  templateUrl: './apps.component.html',
})
export class AppAppsComponent implements OnInit {
  url = `api/v1/sysrRegisterApp/list`;

  searchSchema: SFSchema = {
    properties: {
      //æç´¢å±æ§è®¾ç½®
      appName: {
        type: 'string',
        title: 'ç³»ç»åç§°'
      }
    }
  };
  @ViewChild('st') st: STComponent;
  columns: STColumn[] = [
    { title: 'ç³»ç»ID', index: 'appId' },
    { title: 'ç³»ç»åç§°', index: 'appName' },
    { title: 'çæ¬å·', index: 'rsvn' },
    { title: 'ç³»ç»ç±»å', render: 'typeApp' },
    { title: 'è®¤è¯æ¹å¼', render: 'typeAuth' },
    { title: 'å¤æ³¨è¯´æ', index: 'remark' },
    { title: 'æ³¨åæ¥æ', type: 'date', index: 'createDate' },
    { title: 'å®å¨æ§IPå¯ç¨æ è®°', index: 'flagIpText' },
    { title: 'ç»å½æ¥å¿å¯ç¨æ è®°', index: 'flagLLogText' },
    { title: 'æä½æ¥å¿å¯ç¨æ è®°', index: 'flagLogOptText' },
    { title: 'å¯ç¨ç¶æ', index: 'statusText' },
    {
      title: 'æä½',
      width: '100px',
      buttons: [
        { text: 'æ¥ç', type: 'static', component: AppAppsViewComponent, click: 'reload' },
        {
          text: '',
          children: [

            { text: 'ç¼è¾', type: 'static', component: AppAppsEditComponent, click: 'reload' },
            { text: 'å é¤', type: 'del', click: (item: any) => {
                //å é¤
                this.http.delete(`api/v1/sysrRegisterApp/${item.appId}`).subscribe(res => {
                  this.msgSrv.success('å é¤æå');
                  this.st.reload();
                });
              }},
          ],
        },
      ]
    }
  ];

  constructor(private http: _HttpClient,
              private modal: ModalHelper,
              private msgSrv: NzMessageService,
              private cacheService: CacheService,
              public dictService: DictService) { }

  ngOnInit() { }

  add() {
    this.modal
      .createStatic(AppAppsEditComponent, {})
      .subscribe(() => this.st.reload());
  }

}
